<div class="row" style="overflow-x: hidden !important;" *ngIf="isShowPreferedCommunication">
    <div class="col-md-12 col">
        <div class=" forgotcard">
            <div class="card-content">
                <div class="card-body login-img" style="padding: 0rem;">
                    <div class="">
                        <!-- <form [formGroup]="preferedCommmunicationForm" class="form form-horizontal" novalidate> -->
                        <form [formGroup]="preferedCommmunicationForm">

                            <div class="form-body">
                                <div class="form-group row" style="background-color: #7A02C3;color: white;padding: 2%;">
                                    <div class="col-lg-11 col-md-11 col-sm-11"
                                        style="font-size: x-large;width: fit-content;">
                                        <div>
                                            <a style="cursor:pointer">
                                                <span style="font-size: x-large;"><i class="fa-solid fa-envelope"></i>
                                                    Home Connect Authentication</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="row pl-5 pr-5">
                                    <div class="col-md-12">
                                        Please note that Home-Connect makes use of authentication over Email, SMS and
                                        WhatsApp.
                                    </div>
                                </div>
                                <br />
                                <div class="cardContentClass chooseBTN pl-5 pr-5 col-sm-12 col-md-12"
                                    style="position: relative; align-self: end;">
                                    <!-- <div class="row radioBtnregisterScreeen"> -->
                                    <!-- <div class="col-lg-12 col-md-12 "> -->
                                    <!-- <label class="increaseFomt">Select Title</label> -->
                                    <small class="MytextColor form-text radio-btn-untouched text-muted danger"
                                        style="color: black !important;padding-bottom: 3%;">
                                        Kindly chose your preferred method of communication.</small>
                                    <mat-radio-group style="padding-bottom: 3%;" aria-label="Select an option"
                                        class="tp-radio-button col-md-12 col-lg-12 col-sm-12"
                                        formControlName="preferedType"
                                        style="padding: 0px;display: flex;float: left !important;">
                                        <mat-radio-button value="2" (click)="handleSelectTitleClickEvent('2')"><span
                                                class="increaseFomt radio-btn-style">SMS</span></mat-radio-button>&nbsp;&nbsp;&nbsp;&nbsp;
                                        <mat-radio-button value="3" (click)="handleSelectTitleClickEvent('3')"><span
                                                class="increaseFomt radio-btn-style">WhatsApp</span></mat-radio-button>&nbsp;&nbsp;&nbsp;&nbsp;
                                    </mat-radio-group>
                                </div>
                                <br />
                                <div *ngIf="toShow">
                                    <div class="row pl-5 pr-5">
                                        <div class="col-md-12">
                                            <br /> {{ title }}
                                        </div>
                                    </div>
                                    <div class="form-actions "
                                        style="text-align: end;padding-top: 2%; padding-bottom: 2%;  padding-right: 4%;">
                                        <button class="btn btn-secondary" (click)="saveCustomerRequest()">Submit
                                        </button>
                                    </div>
                                </div>
                                <!-- <div class="form-actions text-center">
                                    <button class="btn btn-secondary" (click)="saveCustomerRequest()">Submit
                                    </button>
                                </div> -->
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row" style="overflow-x: hidden !important;" *ngIf="isShowInCompleteProfile">
    <div class="col-md-12 col">
        <div class=" forgotcard">
            <div class="card-content">
                <div class="card-body login-img">
                    <div class="">
                        <!-- <form [formGroup]="confirmForm" class="form form-horizontal" novalidate> -->
                        <div class="form-body">
                            <div class="row" style="background-color: #7A02C3;color: white;padding: 2%;">
                                <div class="col-9 pl-4 pt-1 pb-1" style="font-size: x-large;">
                                    <div>
                                        <a style="cursor:pointer">
                                            <span style="font-size: x-large;">Information</span>
                                        </a>
                                    </div>
                                </div>
                                <div class="col-3 pt-2 pr-4" style="text-align: right;">
                                    <a style="cursor:pointer">
                                        <i class="fa-solid fa-xmark" (click)="close()" style="font-size: xx-large;"></i>
                                    </a>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12 col-md-12 mt-2">
                                    <p style="    padding-left: 2%;
                                        font-size: 18px;
                                        color: black;
                                        text-align: center; ">Your profile is incomplete.Please provide us the required
                                        information(Gender & Date Of Birth & Id/Passport Number)</p>

                                </div>

                            </div><br>
                            <div class="form-actions" style="display:flex;justify-content:center; gap:4%">
                                <button
                                    style="font-weight: bolder;font-size: 1.5rem !important;width:max-content; padding-left:4%; padding-right:4%"
                                    class="btn btn-primary btn-full-width mb-3">ok
                                </button>
                            </div>
                        </div>
                        <!-- </form> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row" style="overflow-x: hidden !important;" *ngIf="isShowExistingOrders">
    <div class="col-md-12 col">
        <div class=" forgotcard">
            <div class="card-content">
                <div class="card-body login-img">
                    <div class="">
                        <!-- <form [formGroup]="confirmForm" class="form form-horizontal" novalidate> -->
                        <div class="form-body">
                            <div class="row" style="background-color: #7A02C3;color: white;padding: 2%;">
                                <div class="col-9 pl-4 pt-1 pb-1" style="font-size: x-large;">
                                    <div>
                                        <a style="cursor:pointer">
                                            <span style="font-size: x-large;">Check Coverage</span>
                                        </a>
                                    </div>
                                </div>
                                <div class="col-3 pt-2 pr-4" style="text-align: right;">
                                    <a style="cursor:pointer">
                                        <i class="fa-solid fa-xmark" (click)="close()" style="font-size: xx-large;"></i>
                                    </a>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12 col-md-12 mt-2">
                                    <p style="    padding-left: 2%;
                                        font-size: 18px;
                                        color: black;
                                        text-align: center; ">You have no existing orders, would you like to check
                                        coverage?</p>
                                </div>
                            </div><br>
                            <div class="row mb-4" style="justify-content: center;">
                                <!-- <button class="dialogButton btn btn-primary mt-2" (click)="saveExistingOrders('1')">Yes
                                </button>
                                <button class="dialogButton btn btn-primary ml-2 mt-2"
                                    (click)="saveExistingOrders('0')"> No
                                </button> -->

                                <button class="btn btn-primary mb-3 button-size" matBu
                                (click)="saveExistingOrders('1')">Yes</button>&nbsp;&nbsp;&nbsp;
                                <button class="btn btn-primary mb-3 btn-secondary button-size" matBu
                                (click)="saveExistingOrders('0')">No</button>
                            </div>
                        </div>
                        <!-- </form> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row" style="overflow-x: hidden !important;" *ngIf="isShowCompleteVumatelOrder">
    <div class="col-md-12 col">
        <div class=" forgotcard">
            <div class="card-content">
                <div class="card-body login-img">
                    <div class="">
                        <!-- <form [formGroup]="confirmForm" class="form form-horizontal" novalidate> -->
                        <div class="form-body">
                            <div class="row" style="background-color: #7A02C3;color: white;padding: 2%;">
                                <div class="col-9 pl-4 pt-1 pb-1" style="font-size: x-large;">
                                    <div>
                                        <a style="cursor:pointer">
                                            <span style="font-size: x-large;">Warning</span>
                                        </a>
                                    </div>
                                </div>
                                <div class="col-3 pt-2 pr-4" style="text-align: right;">
                                    <a style="cursor:pointer">
                                        <i class="fa-solid fa-xmark" (click)="close()" style="font-size: xx-large;"></i>
                                    </a>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12 col-md-12 mt-2">
                                    <p style="    padding-left: 2%;
                                        font-size: 18px;
                                        color: black;
                                        text-align: center; ">Please Complete Vumatel application</p>
                                </div>

                            </div><br>
                            <div class="row mb-4" style="justify-content: center;">
                                <button class="btn btn-primary mt-2">Ok
                                </button>
                            </div>
                        </div>
                        <!-- </form> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row" style="overflow-x: hidden !important;" *ngIf="isShowConfirmationDate">
    <div class="col-md-12 col">
        <div class="forgotcard">
            <div class="card-content">
                <div class="card-body login-img">
                    <div class="">
                        <form [formGroup]="ConfirmationDateForm" class="form form-horizontal">
                            <div class="form-body">
                                <div class="form-group row" style="background-color: #7A02C3;color: white;padding: 2%;">
                                    <div class="col-9 pl-4 pt-1 pb-1" style="font-size: x-large;">
                                        <div>
                                            <a style="cursor:pointer">
                                                <span style="font-size: x-large;">Select Month And Year</span>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="col-3 pt-2 pr-4" style="text-align: right;">
                                        <a style="cursor:pointer">
                                            <i class="fa-solid fa-xmark" (click)="close()"
                                                style="font-size: xx-large;"></i>
                                        </a>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-3"></div>
                                    <div class="cardContentClass  col-md-6" style="position: relative;">
                                        <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                                            <mat-label>Month and Year</mat-label>
                                            <input readonly matInput  [matDatepicker]="startDate"
                                                id="startDate" formControlName="startDate" autocomplete="off"
                                                placeholder="Month and Year" class="col-12 custom-input-border"
                                                specialIsAlphaNumeric required (click)="FnstartDatePicker()"
                                                style="color:black;">
                                            <mat-datepicker-toggle matSuffix [for]="startDate" style="color:black;">
                                                <button mat-icon-button>
                                                    <mat-icon>event</mat-icon>
                                                    <!-- Using the 'event' icon here -->
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                                                        viewBox="0 0 24 24" stroke="currentColor">
                                                        <!-- Your SVG path or content here -->
                                                    </svg>
                                                </button>
                                            </mat-datepicker-toggle>
                                            <mat-datepicker #startDate startView="multi-year"
                                                (monthSelected)="setMonthAndYear($event, startDate)"
                                                panelClass="example-month-picker">
                                            </mat-datepicker>
                                        </mat-form-field>
                                        <div style="height: 20px;position: absolute;color: red;">
                                            <span class="form-text danger mandatory"
                                                *ngIf="!ConfirmationDateForm.get('startDate').valid &&
                                            (ConfirmationDateForm.get('startDate').dirty || ConfirmationDateForm.get('startDate').touched)">
                                                Start Date is required
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-3"></div>
                                </div>
                                <div class="row mb-4" style="justify-content: center;margin-top:3%">
                                    <button class="btn btn-primary mt-2" (click)="onApply()">Apply</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row" style="overflow-x: hidden !important;" *ngIf="isShowFrogFootLinkStatus">
    <div class="col-md-12 col">
        <div class="forgotcard">
            <div class="card-content">
                <div class="card-body login-img">
                    <div class="">
                        <!-- <form [formGroup]="ConfirmationDateForm" class="form form-horizontal"> -->
                        <div class="form-body">
                            <div class="form-group row" style="background-color: #7A02C3;color: white;padding: 2%;">
                                <div class="col-9 pl-4 pt-1 pb-1" style="font-size: x-large;">
                                    <div>
                                        <a style="cursor:pointer">
                                            <span style="font-size: x-large;">Check Status</span>
                                        </a>
                                    </div>
                                </div>
                                <div class="col-3 pt-2 pr-4" style="text-align: right;">
                                    <a style="cursor:pointer">
                                        <i class="fa-solid fa-xmark" (click)="close()" style="font-size: xx-large;"></i>
                                    </a>
                                </div>
                            </div>
                            <div style="padding-bottom: 10px;">
                                <div class="row">
                                    <div class="container" style="position: relative;">
                                        <label class="col-lg-2 control-label">

                                        </label>
                                        <label class=" col-lg-4 CheckStatusHeading control-label">
                                            <b>Current Step Name</b>
                                        </label>
                                        <label class=" col-lg-6 CheckStatusResponse control-label lblName">
                                            {{ displayCurrentStepName }}
                                        </label>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="container" style="position: relative;">
                                        <label class="col-lg-2 control-label">

                                        </label>
                                        <label class="col-lg-4 CheckStatusHeading control-label">
                                            <b>Current Description</b>
                                        </label>
                                        <label class="col-lg-6 CheckStatusResponse control-label lblName">
                                            {{ displayCurrentDescription }}
                                        </label>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="container" style="position: relative;">
                                        <label class="col-lg-2 control-label">

                                        </label>
                                        <label class="col-lg-4 CheckStatusHeading control-label">
                                            <b>Current Work flow Name</b>
                                        </label>
                                        <label class="col-lg-6 CheckStatusResponse control-label lblName">
                                            {{ displayCurrentWorkflowName }}
                                        </label>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="container" style="position: relative;">
                                        <label class="col-lg-2 control-label">

                                        </label>
                                        <label class="col-lg-4 CheckStatusHeading control-label">
                                            <b>Original Estimated Live Date</b>
                                        </label>
                                        <label class="col-lg-6 CheckStatusResponse control-label lblName">
                                            {{ displayOriginalEstimatedLiveDate }}
                                        </label>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="container" style="position: relative;">
                                        <label class="col-lg-2 control-label">

                                        </label>
                                        <label class="col-lg-4 CheckStatusHeading control-label">
                                            <b>Current Estimated Live Date</b>
                                        </label>
                                        <label class="col-lg-6 CheckStatusResponse control-label lblName">
                                            {{ displayCurrentEstimatedLiveDate }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- </form> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>